import routes from '../../config/routes';

const isThisLocation = (localPath, pathname) => pathname.substring(0, localPath.length) === localPath;

const itemIsSelected = (_path, pathname) => {
  // Handle root path - should match Device Overview (first item in Device Management)
  if (pathname === '/' || pathname === '' || pathname.trim() === '/') {
    return _path === '/statistics/deviceOverview';
  }
  
  // If no specific location is matched, don't default to any item
  if (routes.find((route) => route.path === pathname) === undefined) {
    if (pathname.includes('/statistics/deploymentDetails/') || pathname.includes('/statistics/deploymentStatus')) {
      return false;
    }
    // Removed the default fallback to '/assets' to prevent incorrect section expansion
    return false;
  }
  return isThisLocation(_path, pathname);
};

export default itemIsSelected;
